import {Avatar, Stack, styled} from '@mui/material';

const GuardianRow = styled(Stack)<{$disabled?: boolean}>`
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 12px 16px;
	width: 100%;
	border: 1px solid ${({theme}) => theme.colors.gray['30Percent']};
	border-radius: 8px;
	cursor: ${({$disabled}) => ($disabled ? 'default' : 'pointer')};

	${({theme}) => theme.breakpoints.up('md')} {
		width: 376px;
	}
`;

const GuardianAvatar = styled(Avatar)<{$disabled?: boolean}>`
	background-color: ${({theme, $disabled}) =>
		$disabled ? theme.colors.gray['20Percent'] : theme.colors.light.primary['170Percent']};
	color: ${({theme, $disabled}) =>
		$disabled ? theme.colors.gray['50Percent'] : theme.palette.primary.contrastText};
	width: 40px;
	height: 40px;
	font-size: 14px;
`;

export {GuardianRow, GuardianAvatar};
